import { useApiQuery } from 'theSource/utils';
import { RestrictionsDto } from './types';
import { GET_RESTRICTIONS_QUERY_KEY } from './utils';

export interface UseRestrictionsQueryProps {
  orgLifeEventID: number;
  orgPlanYearID: number;
  enabled: boolean;
}

export const useRestrictionsQuery = ({
  orgLifeEventID,
  orgPlanYearID,
  enabled,
}: UseRestrictionsQueryProps) => {
  const { data, isLoading, isFetching } = useApiQuery<RestrictionsDto>({
    queryKey: [GET_RESTRICTIONS_QUERY_KEY, orgLifeEventID],
    endpoint: `/life_events/${orgLifeEventID}/restrictions`,
    enabled: enabled,
    params: {
      org_plan_year_id: orgPlanYearID,
    },
  });

  return {
    data,
    isLoading,
    isFetching,
  };
};
